import request from './request'

/**
 * 开奖号码分页查询
 * @param {Object} data - { pageNum, pageSize, lotteryType }
 *   lotteryType 彩票类型：klb=快乐8 / ssq=双色球 / dlt=大乐透 / qlc=七乐彩
 * @returns {Promise} data 为 { total, rows }，rows 每行：
 *   {
 *     lotteryType: 'ssq',     // 彩票类型
 *     drawNumIssue: 2026113,  // 开奖号码期号
 *     drawNumTime: '2026-09-29 21:15:00', // 开奖号码时间
 *     drawNumDTO: { redNum: '03,04,...', blueNum: '11' } // 开奖号码对象
 *   }
 */
export function getDrawNumPage(data) {
  return request({
    url: '/lottery/page/draw/num',
    method: 'post',
    data
  })
}

/**
 * 查询各彩票类型的最新一期开奖号码（无入参，一次返回四种彩票）
 * @returns {Promise} data 为数组，每行结构：
 *   {
 *     lotteryType: 'klb',        // 彩票类型：klb / ssq / dlt / qlc
 *     drawNumIssue: 2026263,     // 开奖号码期号
 *     drawNumTime: '2026-09-30 21:30:00', // 开奖号码时间
 *     drawNumTimeInfo:'每日 21:30 开奖'
 *     drawNumDTO: {              // 开奖号码对象
 *       redNum: '07,08,...',     // 红球/主号码，英文逗号拼接，可能为 null
 *       blueNum: '11'            // 蓝球/辅助号码，英文逗号拼接，可能为 null
 *     }
 *   }
 */
export function getLastDrawNumList() {
  return request({
    url: '/lottery/list/last/draw/num',
    method: 'post'
  })
}

/**
 * 投注号码分页查询（投注号码列表）
 * @param {Object} data - { pageNum, pageSize, lotteryType }
 *   lotteryType 彩票类型：klb=快乐8 / ssq=双色球 / dlt=大乐透 / qlc=七乐彩
 * @returns {Promise} data 为 { total, rows }，rows 每行：
 *   {
 *     lotteryType: 'ssq',      // 彩票类型
 *     betType: 'multiple',     // 投注方式：single=单式，multiple/complex=复式
 *     betNumIssue: 2026263,    // 投注期号
 *     playType: '7+1',         // 玩法/号码组合模式
 *     betNumDTO: {             // 投注号码对象
 *       redNum: '1,2,3,4,5,6,7', // 红球/主号码，英文逗号拼接
 *       blueNum: '1'             // 蓝球/辅助号码，英文逗号拼接，可能为 null
 *     },
 *     betTime: '2026-10-04 17:00:03', // 投注时间
 *     drawTime: '2026-10-05 21:30:00' // 开奖时间
 *     numStatus : 'not_win', // 中奖状态：not_win=未中奖，win=中奖 pending=待兑奖
 *     prizeDetail: null        // 中奖情况说明，未开奖时为 null
 *   }
 */
export function getBetNumPage(data) {
  return request({
    url: '/lottery/page/bet/num',
    method: 'post',
    data
  })
}

/**
 * 查询当前允许投注（购买）的期号列表
 * @param {Object} data - { lotteryType }
 *   lotteryType 彩票类型：klb=快乐8 / ssq=双色球 / dlt=大乐透 / qlc=七乐彩
 * @returns {Promise} data 为数组，每行：
 *   {
 *     betNumIssue: 2026264,                  // 可购买的期号
 *     drawNumTime: '2026-10-05 21:30:00'     // 该期开奖时间
 *   }
 */
export function getAllowBetNumInfo(data) {
  return request({
    url: '/lottery/query/allow/bet/num/info',
    method: 'post',
    data
  })
}

/**
 * 投注（购买号码）：随机机选或提交手填号码
 * @param {Object} data - { lotteryType, playType, betNumSource, betNumIssue, betNumDrawTime, betNumDTOs }
 *   lotteryType    彩票类型：klb / ssq / dlt / qlc
 *   playType       玩法/组合模式：klb 取 1~10；ssq 如 6+1、7+2；dlt 如 5+2、6+2
 *   betNumSource   号码来源：random=随机生成 / manual=手动输入
 *   betNumIssue    购买期号（字符串），如 "2026264"，来自 getAllowBetNumInfo
 *   betNumDrawTime 投注号码开奖时间，如 "2026-10-05 21:30:00"，来自 getAllowBetNumInfo 返回的 drawNumTime
 *   betNumDTOs     【仅手动输入时传】投注号码数组：
 *                  [{ redNum: '13,15,29,39,43,53,59,63,64,71', blueNum: null }]
 *                  blueNum 没有蓝球时传 null；双色球如 { redNum: '1,2,3,4,5,6', blueNum: '7' }
 *                 随机机选时可不传该字段，由后端生成号码
 * @returns {Promise} data 为投注结果对象：
 *   {
 *     lotteryType: 'klb',              // 彩票类型
 *     playType: '10',                 // 玩法/组合模式
 *     betNumIssue: 2026267,           // 购买期号
 *     betNumSource: 'random',         // 号码来源
 *     betNumDrawTime: '2020-10-08 21:30:00', // 开奖时间
 *     betNumDTOs: [                   // 投注号码数组（随机/手动均返回）
 *       { redNum: '13,18,29,34,43,53,54,59,61,75', blueNum: null }
 *     ]
 *   }
 */
export function betNum(data) {
  return request({
    url: '/lottery/bet/num',
    method: 'post',
    data
  })
}

/**
 * 待兑奖号码分页查询（兑奖管理-待兑奖列表）
 * @param {Object} data - { pageNum, pageSize, lotteryType }
 *   lotteryType 彩票类型：klb=快乐8 / ssq=双色球 / dlt=大乐透 / qlc=七乐彩
 * @returns {Promise} data 为 { total, rows }，rows 每行：
 *   {
 *     id: 2,
 *     lotteryType: 'ssq',      // 彩票类型
 *     betType: 'multiple',     // 投注方式：single=单式，multiple/complex=复式
 *     betNumIssue: 2026263,    // 投注期号
 *     playType: '7+1',         // 玩法/号码组合模式
 *     betNumDTO: { redNum: '1,2,3,4,5,6,7', blueNum: '1' }, // 投注号码对象
 *     betTime: '2026-10-04 17:00:03' // 投注时间
 *     drawTime: '2026-10-05 21:30:00' // 开奖时间
 *   }
 */
export function getPendingNumPage(data) {
  return request({
    url: '/lottery/page/pending/num',
    method: 'post',
    data
  })
}

/**
 * 兑奖（手动/预约共用）：用户手填期号和号码，查询中奖结果
 * @param {Object} data - { lotteryType, prizeType, playType, betNumIssue, betNumDTOs, saveNumListFlag, emailNotification }
 *   lotteryType      彩票类型：klb / ssq / dlt / qlc
 *   prizeType        兑奖方式：manual=手动兑奖，reserve=预约兑奖
 *   playType         玩法/组合模式：klb 取 1~10；ssq 如 6+1、7+2；dlt 如 5+2、6+2
 *   betNumIssue      兑奖期号（数字），如 2026263
 *   betNumDTOs       待兑奖号码数组：
 *                    [{ redNum: '11,13,22,39,43,53,59,62,64,70', blueNum: null }]
 *                    双色球如 { redNum: '1,2,3,4,5,6', blueNum: '7' }
 *   saveNumListFlag  是否保存到号码列表：true=保存，false=不保存（默认 false）
 *   emailNotification 是否邮箱通知：true=通知，false=不通知（默认 false，仅预约兑奖使用）
 * @returns {Promise} data 为结果描述字符串，如 "恭喜中奖!匹配6个号码[...],获得四等奖,奖金5元."
 */
export function numPrize(data) {
  return request({
    url: '/lottery/num/prize',
    method: 'post',
    data
  })
}

/**
 * 模型推荐号码分页查询（购买彩票页点击"模型推荐"后展示的列表）
 * @param {Object} data - { pageNum, pageSize, lotteryType }
 *   pageNum  页码，从 1 开始
 *   pageSize 每页条数，如 10
 *   lotteryType 彩票类型：klb=快乐8 / ssq=双色球 / dlt=大乐透 / qlc=七乐彩
 * @returns {Promise} data 为 { total, rows }，rows 每行：
 *   {
 *     lotteryType: 'klb',              // 彩票类型
 *     playType: '9',                   // 玩法/号码组合模式，快乐8为选号个数
 *     recommendBetNumIssue: 2026274,   // 推荐号码期号
 *     recommendBetNumTime: '2026-10-15 21:30:00', // 该期开奖时间
 *     recommendNumStatus: 'alreadyPrize', // 兑奖状态：alreadyPrize=已兑奖（已开奖出结果）
 *     betNumDTO: {                     // 推荐号码对象
 *       redNum: '09,14,...',           // 主号码，英文逗号拼接
 *       blueNum: null                  // 辅助号码，没有则为 null
 *     },
 *     recommendModel: 'qwen3.8-max',   // 推荐模型名称
 *     prizeDetail: '恭喜中奖！...'     // 兑奖结果描述，已兑奖才有值
 *   }
 */
export function pageRecommandNum(data) {
  return request({
    url: '/lottery/page/recomand/num',
    method: 'post',
    data
  })
}
